import {camelCase} from 'lodash'

function fromSnakeCaseToCamelCaseReviver(key, value) {
  let result;

  if (key) {
    const camelCasedKey = camelCase(key);

    if (camelCasedKey === key) {
      result = value;
    } else {
      this[camelCase(key)] = value;
    }
  } else {
    result = value;
  }

  return result;
}


export {
  fromSnakeCaseToCamelCaseReviver,
};
